import { CopilotKit as CopilotKitCore } from '@copilotkit/react-core';
import { FC, PropsWithChildren } from 'react';

export const CopilotKit: FC<PropsWithChildren> = ({ children }) => {
  return (
    <CopilotKitCore runtimeUrl="/copilot/run" showDevConsole={false}>
      {children}
    </CopilotKitCore>
  );
};

// eslint-disable-next-line import/no-default-export
export default CopilotKit;
